/**
 * Field Button component
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'wix-style-react'
import styled from 'styled-components'

import Text from 'components/common/Text'

const IconContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

class FieldButton extends Component {
  render () {

    return (
      <Tooltip
        content={<Text>{this.props.label}</Text>}
        hideDelay={0}
        maxWidth=''
        onClickOutside={null}
        onShow={function () {}}
        shouldCloseOnClickOutside
      >
        <div
          style={{display: 'inline-block', verticalAlign: 'top'}}
          className={this.props.className}>
          <Button
            height='medium'
            theme={this.props.isActive ? 'icon-white' : 'icon-standard'}
            onClick={() => this.props.clickHandler()}>
            <IconContainer className='js-field-button'>
              {this.props.icon}
            </IconContainer>
          </Button>
        </div>
      </Tooltip>
    )
  }
}

FieldButton.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.object,
  className: PropTypes.string,
  isActive: PropTypes.bool
}

export default FieldButton



// WEBPACK FOOTER //
// ./src/components/editor/FieldButton.js